import React from 'react'
import './RecLeague.css'

const RecLeague = ({week, gameDate, scheduleGameTime}) => {
  const colorMapping = {
    RED : 'red',
    ORANGE: 'darkorange',
    BLACK: 'black',
    GREEN: 'green',
    BLUE: 'blue',
    PURPLE: 'purple',
    WHITE: 'gray',
    PINK: 'hotpink',
    YELLOW: 'orange',
    S_1: 'purple',
    S_2: 'orange',
    O_1 : 'red',
    O_2 : 'black',
    SHERRARD_1: 'purple',
    SHERRARD_2: 'orange',
    ORION_1 : 'red',
    ORION_2 : 'black',
    ALLIE_T1: 'red',
    ISAACSON_T2: 'purple',
    THOMSEN_T3: 'blue',
    JOHNSON_T4: 'darkorange',
    BOHLAND_T5: 'green',
    LITWILER_T1: 'red',
    WILKEN_HOUSER_T2: 'purple',
    ALLERUZZO_HAARS_T3: 'blue',
    DEAN_T4: 'darkorange',
    
  }

  return (
    <div className="recLeague__container">
      <h3 className="recLeague__week">{week}</h3>
      <h4 className="recLeague__date">{gameDate}</h4>

      <table className="recLeague__table">
        <thead className="recLeague__thead">
          <tr className="recLeague__tr">
            <th className="recLeague__th">Time</th>
            <th className="recLeague__th">Home</th>
            <th className="recLeague__th"></th>
            <th className="recLeague__th">Away</th>
            <th className="recLeague__th">Field #</th>
          </tr>
        </thead>
        <tbody className="recLeague__tbody">
          {scheduleGameTime.map((game, index) => (
            <tr className="recLeague__tr" key={index}>
              <td className="recLeague__td ">
                <span className="recLeague__td">{game.time}</span>
                </td>
              <td className="recLeague__td">
                <span className="recLeague__td"
                  style={{
                    color: colorMapping[game.homeTeam.toUpperCase()] || 'black',
                  }}
                >
                  {game.homeTeam.toUpperCase()} 
                </span>
              </td>
              <td className="recLeague__td">
                <span className="recLeague__td-vs">
                  vs
                </span>
              </td>
              <td className="recLeague__td">
                <span className="recLeague__td"
                  style={{
                    color: colorMapping[game.awayTeam.toUpperCase()] || 'black',
                  }}
                >
                  {game.awayTeam.toUpperCase()}
                </span>
              </td>
              <td className="recLeague__td">
                <span className="recLeague__td">
                  {game.field}
                </span>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default RecLeague